import { Link } from 'react-router-dom';
import Logo from '@/components/feature/Logo';

type Item = { label: string; to: string };
type Col = { title: string; href: string; items: Item[] };

const cols: Col[] = [
  {
    title: 'Navigate',
    href: '/',
    items: [
      { label: 'Home', to: '/' },
      { label: 'About', to: '/#founders' },
      { label: 'Sponsors', to: '/partners' },
    ],
  },
  {
    title: 'Explore',
    href: '/calendar',
    items: [
      { label: 'Tournaments', to: '/calendar' },
      { label: 'Courses', to: '/#courses' },
      { label: 'Watch', to: '/watch' },
    ],
  },
  {
    title: 'Learn',
    href: '/news',
    items: [
      { label: 'News & Stories', to: '/news' },
      { label: 'Community', to: '/community' },
      { label: 'The Pro Collective', to: '/pros' },
    ],
  },
  {
    title: 'Contact',
    href: 'tel:5622432854',
    items: [
      { label: 'Call us', to: 'tel:5622432854' },
      { label: 'Advertise', to: '/partners#advertise' },
      { label: 'List an event', to: '/calendar#list-event' },
    ],
  },
];

const isExternal = (to: string) => to.startsWith('tel:') || to.startsWith('mailto:');

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="px-4 md:px-8 py-12 md:py-16 grid grid-cols-2 lg:grid-cols-6 gap-8">
        <div className="col-span-2">
          <Logo tone="onDark" whiteMark to="/" collapseOnMobile={false} />
          <p className="mt-3 font-label uppercase tracking-[0.2em] text-xs text-accent-400">Local &amp; Community Golf</p>
          <p className="mt-5 text-sm text-background-300 max-w-xs">GreenSide News covers local and community golf. Community over clicks — independent, video-first coverage starting in Long Beach.</p>
          <a href="tel:5622432854" className="mt-5 inline-flex items-center gap-2 font-heading font-bold text-xl text-accent-400 cursor-pointer">
            <span className="w-6 h-6 flex items-center justify-center"><i className="ri-phone-line"></i></span>562-243-2854
          </a>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-label uppercase tracking-widest text-sm font-bold text-accent-400 mb-4">
              {isExternal(c.href) ? (
                <a href={c.href} className="cursor-pointer">{c.title}</a>
              ) : (
                <Link to={c.href} className="cursor-pointer">{c.title}</Link>
              )}
            </h4>
            <ul className="space-y-2.5">
              {c.items.map((i) => (
                <li key={i.label}>
                  {isExternal(i.to) ? (
                    <a href={i.to} className="text-sm text-background-200 hover:text-background-50 whitespace-nowrap cursor-pointer">{i.label}</a>
                  ) : (
                    <Link to={i.to} className="text-sm text-background-200 hover:text-background-50 whitespace-nowrap cursor-pointer">{i.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-primary-600 px-4 md:px-8 py-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-xs text-background-300">
        <p className="text-balance">&copy; 2026 GreenSide News. All rights reserved.</p>
        <p className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
          <Link to="/demo-admin" className="hover:text-background-50 whitespace-nowrap cursor-pointer">Management preview</Link>
          <span className="hidden sm:inline text-primary-500" aria-hidden="true">|</span>
          <span className="whitespace-nowrap">Long Beach, California</span>
        </p>
      </div>
    </footer>
  );
}